<template>
    <FormSelectTree
        ref="FormTreeSelect"
        multiple
        :load-options="loadOptions"
        :normalizer="normalizer"
        disable-branch-nodes
        v-bind="$attrs"
        v-on="$listeners"
    />
</template>



<script>
    import FormSelectTree from './FormSelectTree.vue';

    export default {
        name: 'FormProductTreeSelect',
        components: {
            FormSelectTree,
        },
        props: {
            disabledNodes: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                requestProductsTree: this.$req('space/ProductsTree'),
            };
        },
        computed: {
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
        },
        methods: {
            fetchProductsTree(categoryId) {
                return this.requestProductsTree.get({ urlParams: { spaceId: this.spaceId }, requestParams: { category: categoryId } });
            },
            loadOptions({ parentNode }) {
                return this.fetchProductsTree(parentNode?.entityId);
            },
            normalizer(node) {
                return {
                    id: node.entityId,
                    label: node.text,
                    children: node.children === true ? null : node.children,
                    isDisabled: this.disabledNodes.includes(node.entityId),
                };
            },
        },
    };
</script>
